import type { InventoryItem } from "../types";
import inspectElementBg from "../assets/images/inspect-element-bg.png";
import BackgroundImage from "../../../components/ui/BackgroundImage";

export interface AttachmentSlot {
  id: string;
  label: string;
  iconSrc?: string;
}

interface Props {
  item: InventoryItem;
  attachments: AttachmentSlot[];
  onRemoveAttachment: (id: string) => void;
  onBack: () => void;
}

function AttachmentRow({
  label,
  iconSrc,
  onRemove,
}: {
  label: string;
  iconSrc?: string;
  onRemove: () => void;
}) {
  return (
    <div className="flex items-center gap-2.5 bg-gradient-to-b from-[#0f1010] via-[#131313] to-[#0f1010] rounded-md">
      <BackgroundImage
        imageSrc={inspectElementBg}
        imageClassName="!object-fill"
        className="w-[64px] h-[35px] flex items-center justify-center"
      >
        {iconSrc ? (
          <img
            src={iconSrc}
            alt={label}
            className="relative object-contain pointer-events-none z-10"
            style={{ maxWidth: 36, maxHeight: 26 }}
            draggable={false}
          />
        ) : (
          <span className="relative z-10 text-white/20 text-[9px] uppercase tracking-widest select-none">
            empty
          </span>
        )}
      </BackgroundImage>

      <span className="relative z-10 flex-1 text-white text-[14px] 2560px:text-[15px] purista-font">
        {label}
      </span>

      <button
        className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded-full mr-2 cursor-pointer outline-none"
        style={{
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.10)",
          color: "rgba(255,255,255,0.35)",
        }}
        onClick={onRemove}
        title={`Remove ${label}`}
      >
        <svg
          width="8"
          height="8"
          viewBox="0 0 10 10"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        >
          <line x1="1" y1="1" x2="9" y2="9" />
          <line x1="9" y1="1" x2="1" y2="9" />
        </svg>
      </button>
    </div>
  );
}

export function InspectItemModal({
  item: _item,
  attachments,
  onRemoveAttachment,
  onBack,
}: Props) {
  return (
    <div className="flex flex-col gap-2 p-2.5">
      <div className="flex items-center gap-2 mb-0.5">
        <div className="w-[3px] h-4 rounded-full bg-[#137fe3]" />
        <span className="text-[10px] uppercase tracking-widest text-white/50">
          Inspecting Item
        </span>
      </div>

      <div className="flex flex-col gap-2">
        {attachments.map(({ id, label, iconSrc }) => (
          <AttachmentRow
            key={id}
            label={label}
            iconSrc={iconSrc}
            onRemove={() => onRemoveAttachment(id)}
          />
        ))}
      </div>

      <button
        className="w-full mt-1 py-[7px] text-[11px] text-center cursor-pointer outline-none rounded-[6px]"
        style={{
          background: "transparent",
          border: "1px solid rgba(255,255,255,0.07)",
          color: "rgba(255,255,255,0.35)",
        }}
        onClick={onBack}
      >
        Back
      </button>
    </div>
  );
}
